import { TOptions } from '../core/interceptor';
import { IRequestIO, IResponseIO } from '../core/adapter';
import { AdapterIO, IAdapterIO } from '../core/adapter';
import { t_adapter } from '../core/io';

export type RequestNull = IRequestIO;

/**
 * Always returns null as data
 */
export type ResponseNull = IResponseIO & {
  data: null;
};

/**
 *
 */
export class NullAdapterIO
  extends AdapterIO<RequestNull, ResponseNull, TOptions>
  implements IAdapterIO<RequestNull, ResponseNull, TOptions> {
  type = 'null' as t_adapter;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected async _query(path: string, request: RequestNull) {
    return {
      data: null
    };
  }
}
